<template>
  <div class="mt-0 border-t border-gray-400">
    <div class="bg-white">
      <a class="cursor-pointer tab__link block no-underline text-gray-800 flex content-center items-center" @click.prevent="active = !active">
          <div v-if="color" :class="['w-12 h-12 p-2', color]"><img v-if="image" :src="image" class="w-10"></div>
          <img v-if="image && !color" :src="image" class="w-10 m-3">
          <div class="flex-1 font-bold px-3 text-lg">{{title}}</div>
          <span class="down-Arrow px-3 print:hidden" v-show="!active"><i aria-hidden="true" class="material-icons">menu_book</i> <i aria-hidden="true" class="material-icons">expand_more</i></span>
          <span class="up-Arrow px-3 text-block text-red-800" v-show="active"><i aria-hidden="true" class="material-icons text-gray-300">menu_book</i> <i aria-hidden="true" class="material-icons">cancel</i></span>
      </a>
    </div>
    <div v-if="color" class="bg-white p-4 pl-16 relative border-t border-gray-400" v-show="active">
      <div :class="['w-12 h-full absolute left-0 top-0', color]"></div>
        <slot />
    </div>   
    <div v-else class="bg-white p-4 relative border-t border-gray-400" v-show="active">
        <slot />
    </div>                
  </div>
</template>

<script>
export default {

  props: ['title', 'color', 'description', 'image'],

  data () {
  return {
      active: false,
    }
  },
}
</script>
